const REFERENCE_MONDAY = new Date('2024-01-01T00:00:00.000Z');

export const dayOfWeekToReferenceDate = (dayOfWeek: number): string => {
  const offset = dayOfWeek === 0 ? 6 : dayOfWeek - 1;
  const date = new Date(REFERENCE_MONDAY);
  date.setUTCDate(date.getUTCDate() + offset);
  return date.toISOString();
};

export const buildReferenceWeek = () => {
  const days = [];
  let current = 0;
  while (current <= 6) {
    const newDate = new Date(Date.UTC(
      REFERENCE_MONDAY.getUTCFullYear(),
      REFERENCE_MONDAY.getUTCMonth(),
      REFERENCE_MONDAY.getUTCDate() + current,
    ));
    days.push({
      date: newDate.toISOString(),
      day: newDate.getUTCDate(),
      weekDay: new Intl.DateTimeFormat('fr', { weekday: 'long', day: 'numeric' }).format(newDate),
      dayOfWeek: newDate.getUTCDay(),
    });
    current += 1;
  }
  return days;
};

export const mapFavoriteWeekShiftToShift = (shift: Record<string, unknown>) => ({
  ...shift,
  date: dayOfWeekToReferenceDate(Number(shift.dayOfWeek)),
  isValid: true,
  isPublished: false,
});
